import { Container, ContainerPadding, Breakpoints, CTA } from '@volkswagen-onehub/components-core';
import { Close } from '@volkswagen-onehub/icons-core';
import React from 'react';
import { PortalContext } from '../../../context/portal-context';
import { EmptyPersonVehicle } from '../components/empty-person-vehicle';
import { PersonVehicles } from '../components/person-vehicles';
import { ErrorType } from '@esportal/portal-service';

export const VehicleManagerLayer = ({
	onClose,
	onAutoClose,
	onError,
}: {
	onClose: () => void;
	onAutoClose: () => void;
	onError: (errorType: ErrorType) => void;
}) => {
	const { portalService } = React.useContext(PortalContext);
	const userVehicles = portalService.getPersonVehicles().getValue();
	const hasVehiclesOrOrders = (userVehicles?.vehicles?.length ?? 0) > 0 || (userVehicles?.orders?.length ?? 0) > 0;

	return (
		<>
			<Container
				horizontalAlign={'flex-end'}
				padding={{
					top: ContainerPadding.dynamic0100,
					right: {
						[Breakpoints.default]: ContainerPadding.grid001,
						[Breakpoints.b1600]: ContainerPadding.dynamic0100,
					},
					bottom: ContainerPadding.dynamic0100,
				}}
			>
				<CTA
					tag="button"
					emphasis="tertiary"
					onClick={onClose}
					aria-label="Close pop-up"
					icon={<Close variant="default" aria-hidden />}
				/>
			</Container>
			{userVehicles && hasVehiclesOrOrders ? (
				<PersonVehicles vehicles={userVehicles} onAutoClose={onAutoClose} onError={onError} />
			) : (
				<EmptyPersonVehicle onAutoClose={onAutoClose} onError={onError} />
			)}
		</>
	);
};
